import { createStyles, Divider, Theme, WithStyles, withStyles } from '@material-ui/core'
import moment from 'moment'
import * as R from 'ramda'
import React from 'react'

import {
	CompletionStatus,
	IncentiveEarnedItems,
	ParticipantOutcome,
	StipendFrequencyItems,
	WageFrequencyItems
} from '../../../services/Model/Outcome'
import { StateIDs } from '../../../services/Model/Participant'
import { mapToYesOrNoWithNullable, mapYesNoUnknownToBool } from '../../../services/utils'
// tslint:disable-next-line:max-line-length
import ActivityInformationSection from '../../FormTemplates/OutcomesActivityInformationSection/OutcomesActivityInformationSection'
import OutcomesFormActions from '../../FormTemplates/OutcomesFormActions/OutcomesFormActions'
import AcademicAwardDetails from '../FormItems/AcademicAwardDetails'
import IncentiveEarned from '../FormItems/IncentiveEarnedSection'
import JobPlacementSection from '../FormItems/JobPlacementSection'
import { getOutcomesAccordingToStatus, validateForm } from '../formUtils'

import OtherEnrolledAcademicDetails from '../FormItems/OtherEnrolledAcademicDetails'
import OtherEnrolledActivityInformationSection from '../FormItems/OtherEnrolledActivityInformationSection'
import OtherEnrolledCredentialsEarned from '../FormItems/OtherEnrolledCredentialsEarned'
import OutcomeDateItem from 'src/Forms/FormTemplates/CustomOutcomeDate/OutcomeDateItem'
import {updateDateCredentailAttained} from '../../../features/pacticipantOutcomeSlice'
import { connect, ConnectedProps } from 'react-redux'

const mapStateToProps = (state:any) => ({
  // dateCredentialAttained: state.participantOutcome.dateCredentialAttained
});

const mapDispatchToProps = { updateDateCredentailAttained };

const connector = connect(
  mapStateToProps,
  mapDispatchToProps
)

type PropsFromRedux = ConnectedProps<typeof connector>

interface CEProps extends WithStyles<typeof styles>, PropsFromRedux {
	outcomes: ParticipantOutcome
	onSubmit: (outcomes: ParticipantOutcome) => void
	serviceType: string
	employers: any[]
	onLocalOutcomesUpdate: (outcomes: ParticipantOutcome) => void
	outcomesCopy: ParticipantOutcome
}

interface CEState {
	localOutcomes: ParticipantOutcome
}

const setInitialState = (props: CEProps) => {
	return {
		localOutcomes: props.outcomes,
	}
}

const TOP_START_DATE = new Date()

export class CareerExplorationOtherEnrolled extends React.Component<CEProps, CEState> {
	public readonly state: CEState = setInitialState(this.props)
	formRef: React.RefObject<HTMLFormElement> = React.createRef()

	onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isBulk = this.state.localOutcomes.participantEnrollmentType === 2
		const isFormValid = isBulk || validateForm(this.formRef)

		if (isFormValid) {
			this.props.onSubmit(this.state.localOutcomes)
		}
	}

	onCancel = () => {
		this.updateLocalOutcomes(this.props.outcomesCopy)
	}

	updateLocalOutcomes = (outcomes: ParticipantOutcome) => {
		this.setState({
			localOutcomes: outcomes,
		})
    this.props.onLocalOutcomesUpdate(outcomes)
	}

	handleDateChange = (prop: string, value: Date | string) => {
		const updatedOutcomes = { ...this.state.localOutcomes, [prop]: moment(value).format("YYYY-MM-DD") }
		this.setState({
			localOutcomes: updatedOutcomes,
		})
	}

	handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		const { name, value } = e.target
    console.log(`name2=${name}, value=${value}`)
		const updatedOutcomes = { ...this.state.localOutcomes, [name]: value }
    if(name === 'jobPlacementEmployerState' && value == 'RI'){
      updatedOutcomes.jobPlacementEmployerCity = ''
      updatedOutcomes.jobPlacementEmployerZipcode = ''
    }
		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { localOutcomes } = this.state
		const frequencyItem = WageFrequencyItems.find(i => i.label === e.target.value)
		const wageFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			wageFrequency
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleStipendFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { localOutcomes } = this.state
		const frequencyItem = StipendFrequencyItems.find(i => i.label === e.target.value)
		const stipendFrequency = frequencyItem && frequencyItem.value ? frequencyItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			stipendFrequency
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleCompletionStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const updatedOutcomes = getOutcomesAccordingToStatus(value, localOutcomes)

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleIncentiveEarnedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const incentiveEarnedItem = IncentiveEarnedItems.find((i) => i.label === value)
		const incentiveEarnedProp = incentiveEarnedItem && incentiveEarnedItem.value ?
			incentiveEarnedItem.value : null
		const updatedOutcomes = {
			...localOutcomes,
			incentiveEarned: incentiveEarnedProp,
			incentiveType: null,
			stipendAmount: null,
			stipendFrequency: null,
			wageAmount: null,
			wageFrequency: null
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	stipendReceivedHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const updatedOutcomes = {
			...localOutcomes,
			stipendReceived: value === '' || value === null ? null : value === 'Yes',
			stipendAmount: value === 'Yes' ? localOutcomes.stipendAmount : null,
		}

		this.updateLocalOutcomes(updatedOutcomes)
	}

	handleEarnedAcademicDegree = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const earnedDegreeOrCredit = mapYesNoUnknownToBool(e.target.value)
		const { localOutcomes } = this.state

		this.updateLocalOutcomes({
			...localOutcomes,
			earnedDegreeOrCredit,
			creditsEarned: earnedDegreeOrCredit ? localOutcomes.creditsEarned : null,
			academicCredit: earnedDegreeOrCredit ? localOutcomes.academicCredit : null,
		})
	}

	handleBenefitsProvided = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const benefitsProvided = mapYesNoUnknownToBool(value)

		const newOutcomes = {
			...localOutcomes,
			benefitsProvided,
		}

		this.updateLocalOutcomes(newOutcomes);
	}

	handlePerDiem = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const perDiem = mapYesNoUnknownToBool(value)

		const newOutcomes = {
			...localOutcomes,
			perDiem,
			jobPlacementWeeklyHours: null,
			benefitsProvided: false,
		}

		this.updateLocalOutcomes(newOutcomes);
	}

	handlePlacedJob = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target
		const { localOutcomes } = this.state
		const placedJob = mapYesNoUnknownToBool(value)

		const outcomesIfPlacedJob = {
			...localOutcomes,
			placedJob,
			benefitsProvided: null,
			placedJobDate: null,
			jobPlacementEmployer: null,
			jobPlacementEmployerAddress1: null,
			jobPlacementEmployerAddress2: null,
			jobPlacementEmployerCity: null,
			jobPlacementEmployerState: null,
			jobPlacementEmployerZipcode: null,
			jobPlacementIndustry: null,
			jobPlacementOccupation: null,
			jobPlacementWage: null,
			jobPlacementWageFrequency: null,
			jobPlacementWeeklyHours: null,
			paidHours: null,
			perDiem: null,
		}

		this.updateLocalOutcomes(placedJob ? outcomesIfPlacedJob : { ...localOutcomes, placedJob })
	}

  handleDateCredentialAttained = (dateCredentialAttained)=>{
    const { localOutcomes } = this.state
    this.updateLocalOutcomes({...localOutcomes, dateCredentialAttained})
  }

	componentDidMount(): void {
		window.scrollTo(0, 0)
	}

	componentWillReceiveProps(nextProps: CEProps) {
		if (R.equals(this.props.outcomes, nextProps.outcomes)) return

		this.setState((prevState: CEState) => ({ ...prevState, localOutcomes: nextProps.outcomes }))
	}

	render() {
		const { classes } = this.props
    
		const { localOutcomes } = this.state
		const isBulk = localOutcomes.participantEnrollmentType === 2
		const placedJob = mapToYesOrNoWithNullable(localOutcomes.placedJob)

		return (
			<div className={classes.root} data-auto="form-wrapper">
				<Divider variant="middle" style={{ margin: '15px 0' }} />
				<form onSubmit={this.onFormSubmit} ref={this.formRef}>
					<div>
						<ActivityInformationSection
							// Removed: Outcome Actual Start Date — no longer collected
							// startDate={localOutcomes.startDate || undefined}
							endDate={localOutcomes.completionDate || undefined}
							minEndDate={localOutcomes.startDate ? moment(localOutcomes.startDate).format('YYYY-MM-DD') : ''}
							// requiredStartDate={!isBulk}
							requiredEndDate={isBulk ? false : localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							onDateChange={this.handleDateChange}
							// maxStartDate={moment(TOP_START_DATE).format('YYYY-MM-DD')}
							showEndDate={localOutcomes.completionStatus !== CompletionStatus.ENROLLED}
							completionStatus={localOutcomes.completionStatus}
							handleCompletionStatusChange={this.handleCompletionStatusChange}
							dropReason={localOutcomes.dropReason || ''}
							onDropReasonChange={this.handleTextChange}
              serviceType={this.props.serviceType}
						/>
						<IncentiveEarned
							incentiveEarned={localOutcomes.incentiveEarned || undefined}
							onIncentiveEarnedChange={this.handleIncentiveEarnedChange}
							incentiveType={localOutcomes.incentiveType || undefined}
							onIncentiveTypeChange={this.handleTextChange}
              amtRequired={false}
							stipendAmount={localOutcomes.stipendAmount}
							stipendFrequency={localOutcomes.stipendFrequency}
							onStipendAmountChange={this.handleTextChange}
							onStipendFrequencyChange={this.handleStipendFrequencyChange}
							wageAmount={localOutcomes.wageAmount}
							wageFrequency={localOutcomes.wageFrequency || undefined}
							onWageAmountChange={this.handleTextChange}
							onWageFrequencyChange={this.handleFrequencyChange}
              serviceType={this.props.serviceType}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<OtherEnrolledActivityInformationSection
							wblType={localOutcomes.wblType || ''}
							unpaidHours={localOutcomes.unpaidHours || undefined}
							paidHours={localOutcomes.paidHours || undefined}
              unpaidHoursRequired={true}
              paidHoursRequired={true}
							internshipEmployer={localOutcomes.internshipEmployer || ''}
							internshipIndustry={localOutcomes.internshipIndustry || ''}
							internshipOccupation={localOutcomes.internshipOccupation || ''}
							onWblTypeChange={this.handleTextChange}
							onHoursChange={this.handleTextChange}
							onInternshipEmployerChange={this.handleTextChange}
							onInternshipIndustryChange={this.handleTextChange}
							onInternshipOccupationChange={this.handleTextChange}
							header={"Career Exploration Activity Information"}
              serviceType={this.props.serviceType}
              employers={this.props.employers}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div className={classes.block}>
						<OtherEnrolledAcademicDetails
							earnedDegreeOrCredit={localOutcomes.earnedDegreeOrCredit}
							academicCredit={localOutcomes.academicCredit || ''}
							creditsEarned={localOutcomes.creditsEarned || ''}
							credentialType={localOutcomes.credentialType || ''}
							handleEarnedDegreeChange={this.handleEarnedAcademicDegree}
							handleTypeofCreditChange={this.handleTextChange}
							handleCreditsEarnedChange={this.handleTextChange}
							handleTypeOfCredentialChange={this.handleTextChange}
							updateDateCredentailAttained={this.props.updateDateCredentailAttained}
							creditTypeRequired={false}
							creditsEarnedRequired={false}
							credentialTypeRequired={false}
							serviceType={this.props.serviceType}
						/>
						<AcademicAwardDetails onChange={this.handleTextChange} value={localOutcomes.academicAwardDetail || ''} />
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<div>
						<JobPlacementSection
							completionDate={localOutcomes.completionDate || undefined}
							handleJobPlacementEmployer={this.handleTextChange}
							handlePlacedJobChange={this.handlePlacedJob}
							handlePlacedJobDateChange={({ target }) => this.handleDateChange('placedJobDate', target.value)}
							label={'Permanent Job Placement Information'}
							placedJobDate={localOutcomes.placedJobDate || undefined}
							placedJobStringVal={placedJob}
							startDate={localOutcomes.startDate || undefined}
							jobPlacementEmployer={localOutcomes.jobPlacementEmployer || ''}
							jobPlacementEmployerAddress1={localOutcomes.jobPlacementEmployerAddress1 || ''}
							handleJobPlacementEmployerAddress1Change={this.handleTextChange}
							jobPlacementEmployerAddress2={localOutcomes.jobPlacementEmployerAddress2 || ''}
							handleJobPlacementEmployerAddress2Change={this.handleTextChange}
							jobPlacementEmployerCity={localOutcomes.jobPlacementEmployerCity || ''}
							handleJobPlacementCityChange={this.handleTextChange}
							handleEmployerStateChange={this.handleTextChange}
							jobPlacementEmployerState={
								localOutcomes.jobPlacementEmployerState ? StateIDs[localOutcomes.jobPlacementEmployerState] : ''
							}
							jobPlacementEmployerZipcode={localOutcomes.jobPlacementEmployerZipcode || ''}
							handleJobPlacementEmployerZipcodeChange={this.handleTextChange}
							jobPlacementOccupation={localOutcomes.jobPlacementOccupation || ''}
							handleJobPlacementOccupationChange={this.handleTextChange}
							jobPlacementIndustry={localOutcomes.jobPlacementIndustry || ''}
							handleJobPlacementIndustryChange={this.handleTextChange}
							jobPlacementWage={localOutcomes.jobPlacementWage || undefined}
							handleJobPlacementWageChange={this.handleTextChange}
							jobPlacementWageFrequency={localOutcomes.jobPlacementWageFrequency || ''}
							handleWageFrequencyChange={this.handleTextChange}
							jobPlacementWeeklyHours={localOutcomes.jobPlacementWeeklyHours}
							handleJobPlacementWeeklyHoursChange={this.handleTextChange}
							benefitsProvidedStringVal={mapToYesOrNoWithNullable(localOutcomes.benefitsProvided)}
							handleBenefitsProvidedChange={this.handleBenefitsProvided}
							requiredPlacedJobDate={placedJob === "Yes"}
							requiredRole={placedJob === "Yes" || localOutcomes.placedJob === true}
							jobTitle={localOutcomes.jobTitle || ''}
							handleJobTitleChange={this.handleTextChange}
							perDiemStringVal={mapToYesOrNoWithNullable(localOutcomes.perDiem)}
							handlePerDiemChange={this.handlePerDiem}
              employers={this.props.employers}
						/>
					</div>

					<Divider variant="middle" style={{ margin: '15px 0' }} />

					<OutcomesFormActions
						onCancel={this.onCancel}
						isSubmitDisabled={R.equals(this.props.outcomesCopy, this.state.localOutcomes)}
					/>
				</form>
			</div>
		)
	}
}
const styles = (theme: Theme) =>
	createStyles({
		root: {},
    block:{
      display: 'block'
    }
	})

export default connector(withStyles(styles)(CareerExplorationOtherEnrolled))
